import * as L from 'leaflet';
import 'leaflet-bing-layer';
import { IBaseMap } from '../map';


export const API_KEYS = {
    //tomtom: 'NznrHwsQu7XZDebE6cXqEpGEE9y3Fsw8',
    tomtom: '8RmbGbuxLs4STSJvpgA2w8oBiYwA4f1G',
    here: 'xKJgVUvgNPKN721De4ssFvYAeZqP8hE0VbkqfDifOII',
   // bing: 'Ap2c5k4QJ_T7jY0-kmGcksJTPNyon8lGOof7cW_PBnvjHSzp3ymz0CQCPSUq0V-3',
    bing:' AlF8OB-eAjtAmhDnR970zFKlV7BybmwY0zSRLNtOubLBZ8eZ8psI-XMceqoS9Uf5',
    viamichelin: 'RESTGP20200720131132150354924780',
    thunderforest: '330d3583125d430589389cd400ff6ab0'
}

export class MapProvider{
    private selectedBaseMapLayer:IBaseMap ={
        name : '',
        layerName : '',
        type:''
    }
    
    getBaseMapLayer(selectedLayer:IBaseMap){
        let tileLayer:any;
        this.selectedBaseMapLayer = selectedLayer;
        switch(selectedLayer.layerName){
            case 'OpenStreetMap' : 
                tileLayer = this.openstreetmap();
                break;
            case 'Tomtom Routes' :
                tileLayer = this.tomtomMap();
                break;
            case 'ViaMichelin' :
                tileLayer = this.viamichelin();
                break;
            case 'HERE Maps':
            case 'HERE MAPS' :
                tileLayer = this.HEREMaps();
                break;
            case 'Microsoft Bing Maps' :
                tileLayer = this.microsoftBingMap();
                break;
            case 'Thunderforest' :
                tileLayer = this.thunderforest();
                break;
            case 'OpenTopoMap' :
                tileLayer = this.opentopomap();
                break;
            case 'ArcGIS World Map' :
                tileLayer = this.ArgisWorldMap();
                break;
            case 'Mappy Maps':
                tileLayer = this.MappyMap();
                break;
            case 'Waze World Map' :
                tileLayer = this.wazeWorldMap();
                break;
            case 'Yandex Maps':
                tileLayer = this.yandexMap();
                break;
            case 'USA Topographic Maps':
                 tileLayer = this.USATopographicMap();
                 break;
            case 'Waze USA Map':
                 tileLayer = this.wazeUSAMap();
                 break;
            case 'Japan Topographic Map':
                 tileLayer = this.JapanTopographicMap();
                 break;
            case 'Norway Topographic Map':
                 tileLayer = this.NorwayTopographicMap();
                 break;
            case 'Natural Resources Canada Map':
                 tileLayer = this.NaturalResourceCanadaMap();
                 break;
            case 'Australian Topographic Map':
                 tileLayer = this.AustralianTopographicMap();
                 break;
            case 'New Zealand Topographic Map':
                 tileLayer = this.NewZealandTopographicMap();
                 break; 
            case 'Grand-Duche` de Luxembourg':
                 tileLayer = this.GrandDucheluxembourgMap();
                 break;  
            default: tileLayer = this.openstreetmap();
                break;
        }
        return tileLayer;
    }
    private ArgisWorldMap(){
        let viewType = '',
            isSingleLayer = true,
            multiLayerNames = [];
        switch(this.selectedBaseMapLayer.type){
            case 'Map': 
                viewType = 'World_Street_Map';
                isSingleLayer = true;
                break;
            case 'Satellite': 
                viewType = 'World_Imagery';
                isSingleLayer = true;
                break;
            case 'Hybrid': 
                viewType = '--'
                isSingleLayer = false;
                multiLayerNames = ['World_Imagery','Reference/World_Boundaries_and_Places'];
                break;
            case 'Terrain': 
                viewType = 'World_Topo_Map';
                isSingleLayer = true;
                break;
            default: viewType = 'World_Street_Map';
                break;
        }
        
        const url = `https://server.arcgisonline.com/ArcGIS/rest/services/${viewType}/MapServer/tile/{z}/{y}/{x}`;
        if(isSingleLayer){
            return L.tileLayer( url,{ maxZoom: 16});
        }else {
            // NOTE: make sure for url, `viewType='--'` is set in switch case
            return  this.combineTwoLayers(multiLayerNames,url);
        }
       
    }
    // Function to combine TWO or more tileLayers into single one
    private combineTwoLayers(viewType:string[],url:string){
        const tileLayers = [];
        const splitUrl = url.split('--');
        viewType.forEach((type:string) => {
            const finalUrl = `${splitUrl[0]}/${type}/${splitUrl[1]}`;
            tileLayers.push(
                L.tileLayer(finalUrl,{ maxZoom: 16})
            )
        })
        return L.layerGroup(tileLayers);
    }
    private HEREMaps(){
        let viewType ={
            base : 'base',
            scheme: 'normal.day'
        };
        switch(this.selectedBaseMapLayer.type){
            case 'Map' :
                viewType ={
                    base:'base',
                    scheme: 'normal.day'
                }
                break;
            case 'Satellite' :
                viewType ={
                    base : 'aerial',
                    scheme: 'satellite.day'
                }
                break;
            case 'Hybrid' :
                viewType ={
                    base:'aerial',
                    scheme: 'hybrid.day'
                }
                break;
            case 'Terrain' :
                viewType ={
                    base:'aerial',
                    scheme: 'terrain.day'
                }
                break;
        }
        return L.tileLayer(
            `https://1.${viewType.base}.maps.ls.hereapi.com/maptile/2.1/maptile/newest/${viewType.scheme}/{z}/{x}/{y}/256/png8?apiKey=${API_KEYS.here}`,
            {
               maxZoom: 24,
           })
    }

    private MappyMap(){
        let viewType = '';
        switch(this.selectedBaseMapLayer.type){
            case 'Map': 
                viewType = 'base-m';
                break;
            case 'Satellite': 
                viewType = 'bing';
                break;
            case 'Hybrid': 
                viewType = 'bing';
                break;
            default: viewType = 'base-m';
                break;
        }
        return L.tileLayer( `https://mapserver.mapy.cz/${viewType}/{z}-{x}-{y}`,
        {
            maxZoom: 24
        });
    }

    private microsoftBingMap(){
        let viewType = '';
        switch(this.selectedBaseMapLayer.type){
            case 'Map': 
                viewType = 'RoadOnDemand';
                break;
            case 'Satellite': 
                viewType = 'Aerial';
                break;
            case 'Hybrid': 
                viewType = 'AerialWithLabels';
                break;
            default: viewType = 'Aerial';
                break;
        }
        return L.tileLayer['bing']({
            bingMapsKey : API_KEYS.bing,
            imagerySet: viewType
           });
    }
    private openstreetmap(){
        let url ='';
        switch(this.selectedBaseMapLayer.type){
            case 'Map': 
                url = 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'; 
                break;
           
            case 'Terrain': 
            url = 'https://tile.thunderforest.com/cycle/{z}/{x}/{y}.png';
                break;
            default: url = 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
                break;
        }
        return L.tileLayer(url, {  maxZoom: 24 })
    }
    private opentopomap(){
        return L.tileLayer(
        'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', 
        {
        maxZoom: 17
        });
    }   
    private thunderforest(){
        let viewType = '';
        switch(this.selectedBaseMapLayer.type){
            case 'Map': 
                viewType = 'transport';
                break;
            case 'Satellite': 
                viewType = 'spinal-map';
                break;
            case 'Terrain': 
                viewType = 'outdoors';
                break;
            default: viewType = 'transport';
                break;
        }
        return L.tileLayer(
            `https://tile.thunderforest.com/${viewType}/{z}/{x}/{y}.png?apikey=${API_KEYS.thunderforest}`,
            {
            maxZoom: 22
            });
    }
    private tomtomMap(){
        return  L. tileLayer(
            `https://api.tomtom.com/map/1/tile/basic/main/{z}/{x}/{y}.png?&traffic=false&key=${API_KEYS.tomtom}`,
            {
                    maxZoom: 24,
            })
    }
   
    private viamichelin(){
        let viewType = '',
        isSingleLayer = true;
        switch(this.selectedBaseMapLayer.type){
            case 'Map': 
                isSingleLayer = true;
                break;
            case 'Hybrid': 
                isSingleLayer = false;
                break;
            default:  isSingleLayer = true;
                break;
        }
         if(isSingleLayer){
             return L.tileLayer(
             'https://map1.viamichelin.com/map/mapdirect?map=viamichelin&z={z}&x={x}&y={y}&format=png&version=201804131440&layer=background&protocol=https', 
            {
              maxZoom: 24
            })
        }
        else{
            const bingHybrid= L.tileLayer['bing']({
                bingMapsKey : API_KEYS.bing,
                imagerySet: "Aerial"
               });
            
            const viamichelin =  L.tileLayer(
                 'https://map1.viamichelin.com/map/mapdirect?map=hybrid&z={z}&x={x}&y={y}&format=png&version=201503191157&layer=network',
                {
                  maxZoom: 24
                })
                return L.layerGroup([bingHybrid,viamichelin])
        }
    }
    private yandexMap() {
        let viewType = '',
        isSingleLayer = true,
        multiLayerNames = [],
        base='';
        switch(this.selectedBaseMapLayer.type){
            case 'Map': 
                viewType = 'map';
                isSingleLayer = true;
                base="vec02";
                break;
            case 'Satellite': 
                viewType = 'sat';
                isSingleLayer = true;
                base="sat02"
                break;
            case 'Hybrid': 
                isSingleLayer = false;
                break;
            case 'Terrain': 
                isSingleLayer = false;
                break;
            default: viewType = 'map';
                break;
        }
        const url = `https://${base}.maps.yandex.net/tiles?l=${viewType}&x={x}&y={y}&z={z}&scale=1&lang=en_RU`;
        if(isSingleLayer){
            return L.tileLayer( url,{ maxZoom: 30});
        }else {
            // NOTE: make sure for url, `viewType='--'` is set in switch case
            const yandexSatellite =  L.tileLayer(
                `https://sat02.maps.yandex.net/tiles?l=sat&x={x}&y={y}&z={z}&scale=1&lang=en_RU`,
                {
                  maxZoom: 30
                })
            const yandexRoadOnly =  L.tileLayer(
                'https://vec02.maps.yandex.net/tiles?l=skl&x={x}&y={y}&z={z}&scale=1&lang=en_RU', 
                {
                  maxZoom: 30
                })
            const yandexTerrain =  L.tileLayer(
                 'https://vec02.maps.yandex.net/tiles?l=trf&x={x}&y={y}&z={z}&scale=1&lang=en_RU', 
                {
                     maxZoom: 30
                })
                if(this.selectedBaseMapLayer.type==="Terrain") return L.layerGroup([yandexSatellite,yandexRoadOnly,yandexTerrain])
                else return L.layerGroup([yandexSatellite,yandexRoadOnly])
        }
    }
    private wazeWorldMap() {
        return L.tileLayer(
            'https://worldtiles1.waze.com/tiles/{z}/{x}/{y}.png',
            {
                maxZoom: 16
            });
    }
    private USATopographicMap() {
        return L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Physical_Map/MapServer/tile/{z}/{y}/{x}', 
        {                   
            maxZoom: 8
        });
    }
    private wazeUSAMap() {
        return L.tileLayer('https://livemap-tiles4.waze.com/tiles/{z}/{x}/{y}.png',
        {
            maxZoom: 16
        });
    }
    private JapanTopographicMap() {
        return L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png',
        {
            maxZoom: 8
        });
    }
    private NorwayTopographicMap() {
        return L.tileLayer('https://maptiles.finncdn.no/tileService/1.0.3/norortho/{z}/{x}/{y}.png',
        {
            maxZoom: 8
        });
    }
    private NaturalResourceCanadaMap(){
        return L.tileLayer('https://caltopo.s3.amazonaws.com/topo/{z}/{x}/{y}.png',
        {
            maxZoom : 3
        });
    }
    private AustralianTopographicMap(){
        return L.tileLayer('https://b.agri.openstreetmap.org/layer/au_ga_agri/{z}/{x}/{y}.png',
        {
            maxZoom : 8
        });
    }
    private NewZealandTopographicMap(){
        return L.tileLayer('https://tiles-a.data-cdn.linz.govt.nz/services;key=1a3123d1db924eaf844e1cdb4c721135/tiles/v4/layer=50767/EPSG:3857/{z}/{x}/{y}.png',
        {
            maxZoom : 5

        });
    }
    private GrandDucheluxembourgMap(){
        return L.tileLayer('https://wmts3.geoportail.lu/opendata/wmts/basemap/GLOBAL_WEBMERCATOR_4_V3/{z}/{x}/{y}.png',
        {
            maxZoom : 15 
        });
    }
}


